import { NgModule } from '@angular/core';
import { ActionNoPermissionUiService } from './action-no-permission-ui.service';
import { JwActionNoPermissionComponent } from './jw-action-no-permission.component';
import { ActionNoPermissionUiComponent } from './action-no-permission-ui.component';

@NgModule({
	imports: [
	],
	declarations: [
		ActionNoPermissionUiComponent,
		JwActionNoPermissionComponent,
	],
	exports: [
		ActionNoPermissionUiComponent,
		JwActionNoPermissionComponent,
	],
	providers: [
		ActionNoPermissionUiService,
	],
	entryComponents: [
	],
})
export class ActionNoPermissionUiModule { }
